<template>
	<div class="chart-wrap" :id="id" ref="echart" style="width:100%;height:300px;" :style="id==='chart2'?'height:260px':''"></div>
</template>
<script>
import {barOptionConfig} from "@/libs/echartOption/barOption.js";
import {pieOptionConfig} from "@/libs/echartOption/pieOption.js";
import {mapState,mapActions, mapGetters} from 'vuex';

export default {
	name:'vue-echart',
	props:['id'],
	data(){
		return {

		}
	},
	methods:{
		...mapActions(["reqServiceChart","reqServiceReportPreview"]),
		async initChart(){
			if(this.$route.query.id){
				await this.reqServiceChart({id:this.$route.query.id})
			}else{
				await this.reqServiceReportPreview(this.reportQuery)
			}
			let echartConfig = this.getChartConfig(this.id);
			let myChart = document.getElementById(this.id)
			let ChartGraph = this.$echarts.init(myChart)
			ChartGraph.setOption(echartConfig);
			window.addEventListener("resize",function () {
				ChartGraph.resize();
			})
		},
		getChartConfig(id){
			if(id=='chart1'){
				console.log(this.CInventoryData)
				return pieOptionConfig(this.CInventoryData);  //渠道
			}else if(id === 'chart2'){
				return barOptionConfig(this.serviceLowpriceChartData); //违规
			}else if(id==='chart3'){
				return barOptionConfig(this.informreport);//通知整改
			}else{
				return pieOptionConfig(this.IPRCompliantData); //知识产权投诉
			}
		}
	},
	computed:{
		...mapState({
				reportQuery:state=> state.serviceReport.reportQuery
		}),
		...mapGetters(['CInventoryData','informreport','IPRCompliantData','serviceLowpriceChartData'])
	},
	mounted(){
		this.initChart();
	}
}
</script>
